export default "__VITE_ASSET__DarPp3ja__"